import { FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { useErpAuth } from '../../context/ErpAuthContext';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
import { Input } from '../../components/ui/Input';
import './erp.css';

export function ErpLoginPage() {
  const { login } = useErpAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'No se pudo iniciar sesión');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="erp-login-page">
      <Card className="erp-login-card">
        <h1>ERP Hosty</h1>
        <p style={{ color: 'var(--color-text-muted)', marginTop: '0.25rem' }}>
          Acceso restringido a administradores
        </p>
        <form onSubmit={handleSubmit} style={{ marginTop: '1.25rem', display: 'grid', gap: '0.75rem' }}>
          <Input
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="username"
          />
          <Input
            label="Contraseña"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
          />
          {error ? <p style={{ color: 'var(--color-danger)', margin: 0 }}>{error}</p> : null}
          <Button type="submit" disabled={loading}>
            {loading ? 'Entrando…' : 'Entrar'}
          </Button>
        </form>
        <p style={{ marginTop: '1rem', fontSize: '0.9rem' }}>
          <Link to="/">← Volver a la web</Link>
        </p>
      </Card>
    </div>
  );
}
